import { useQuery } from '@tanstack/react-query';
import {
  getScreensMeta,
  skeletonColumnTypeFromApiValue,
} from 'shared/src/api';

/**
 * 검색 결과 화면 전용 meta API 쿼리 훅.
 *
 * iOS `MetaFeedReactor.fetchScreenAppreanceData` / Android `ComponentMetaViewModel`
 * 과 동일한 의도. `GET /screens/{screenName}/meta` 응답의 `skeleton_type`
 * (SEARCH_RESULT는 "3col")을 받아 `SkeletonColumnType`으로 변환한다.
 *
 * 서버의 `SearchResultMetaScreenLoader.load()`가 DB/ES 호출 없이 Screen enum
 * 값만 직렬화하는 정적 응답이라 캐싱 정책은 react-query 기본값을 따른다.
 * `select`에서 `skeletonColumnTypeFromApiValue`가 `'twoCol'` silent fallback 처리.
 */
export const useSearchResultMetaQuery = (screenName: string) =>
  useQuery({
    queryKey: ['searchResultMeta', screenName],
    queryFn: () => getScreensMeta({ screen: screenName }),
    enabled: screenName !== '',
    select: raw => skeletonColumnTypeFromApiValue(raw.screen.skeleton_type),
  });
